<template>
  <!-- The rows of a card sit on their own padding, with none of the body's gap between them -->
  <View direction="column">
    <slot />
  </View>
</template>

<script setup lang="ts">
import { View } from '@tallo/design-system';
</script>
